export const getDropdownValue = (dropdownId: string): string => {
 const dropdown = document.getElementById(dropdownId) as HTMLUxSelectElement;
  for (const option of dropdown.options) {
    if (option.selected) {
      return option.value;
    }
  }
  return "";
};
